import { useLoaderData } from "react-router";
import { Card, Col, Tab, Tabs } from "react-bootstrap";
import { Task, Aggregator } from "../../ApiClient.js";
import "@github/relative-time-element";
import { Copy, OutLink, usePromiseAll3 } from "../../util.js";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import js from "react-syntax-highlighter/dist/esm/languages/hljs/javascript";
import { github as syntaxStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { useCallback } from "react";

SyntaxHighlighter.registerLanguage("javascript", js);

export default function ClientConfig() {
  return (
    <Col md="6">
      <Card className="my-3">
        <Card.Body>
          <Card.Title>Client Config</Card.Title>
          <Tabs defaultActiveKey="ts" id="client-config" className="mb-3">
            <Tab eventKey="ts" title="TypeScript/JavaScript">
              <TsClientConfig />
            </Tab>
            <Tab eventKey="rs" title="Rust">
              <RsClientConfig />
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </Col>
  );
}

function RsClientConfig() {
  return (
    <OutLink href="https://lib.rs/crates/janus_client">
      View Documentation
    </OutLink>
  );
}

function TsClientConfig() {
  const { task, leaderAggregator, helperAggregator } = useLoaderData() as {
    task: Promise<Task>;
    leaderAggregator: Promise<Aggregator>;
    helperAggregator: Promise<Aggregator>;
  };

  const taskConfig = usePromiseAll3(
    task,
    leaderAggregator,
    helperAggregator,
    useCallback(
      ([task, leader, helper]) => ({
        ...task.vdaf,
        id: task.id,
        leader: leader.dap_url,
        helper: helper.dap_url,
        timePrecisionSeconds: task.time_precision_seconds,
      }),
      [],
    ),
    {
      type: null,
      id: null,
      leader: null,
      helper: null,
      timePrecisionSeconds: null,
    } as object,
  );

  const taskArgs = JSON.stringify(taskConfig, null, 2).replace(
    /"([^"]+)":/g,
    "$1:",
  );

  const contents = `import Task from "@divviup/dap";

const task = new Task(${taskArgs});

await task.sendMeasurement(...); // your measurement here`;

  return (
    <>
      <p>
        Copy and paste this code to use{" "}
        <OutLink href="https://github.com/divviup/divviup-ts">
          divviup-ts
        </OutLink>
      </p>

      <Copy clipboardContents={contents}>
        {(copy) => (
          <div
            onClick={copy}
            style={copy && { cursor: "pointer" }}
            className="my-3"
          >
            <SyntaxHighlighter
              language="javascript"
              style={syntaxStyle}
              showLineNumbers
            >
              {contents}
            </SyntaxHighlighter>
          </div>
        )}
      </Copy>

      <p>
        <OutLink href="https://divviup.github.io/divviup-ts/">
          View Documentation
        </OutLink>
      </p>
    </>
  );
}
